<template>
  <div class="vx-collapse">
    <button
      :class="[buttonClasses, {'decorated': decorated, 'collapsed': !localValue}]"
      class="btn"
      type="button"
      :aria-expanded="localValue ? 'true' : 'false'"
      @click="toggleCollapse()"
    >
      <slot name="button"/>

      <v-icon
        icon="arrow-right"
        size="xxs"
        class="collapse-arrow ms-auto"
        v-if="!disableIcon"
      />
    </button>

    <div
      :id="id"
      class="collapse"
      ref="collapse"
      :class="[{'collapse-horizontal': collapseHorizontal}, collapseClasses]"
    >
      <slot name="content"/>
    </div>
  </div>
</template>

<script>

export default {
  name: 'VCollapse',
  data() {
    return {
      collapse: {},
      localValue: false,
    };
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    collapseHorizontal: {
      type: Boolean,
      required: false,
      default: false,
    },
    buttonClasses: {
      type: String,
      required: false,
      default: '',
    },
    collapseClasses: {
      type: String,
      required: false,
      default: '',
    },
    disableIcon: {
      type: Boolean,
      default: false,
    },
    decorated: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.getInstance();
  },
  methods: {
    getInstance() {
      const element = this.$refs.collapse;

      if(!!this.value) {
        this.localValue = this.value;
      }

      if (element) {
        this.collapse = Collapse.getOrCreateInstance(element, {toggle: this.localValue});
      }
    },
    toggleCollapse() {
      this.toggle();

      this.localValue = !this.localValue;

      this.$emit('click')
      this.$emit('toggle')
    },
    toggle() {
      this.collapse.toggle();

      this.$emit('toggle');
    },
    show() {
      this.collapse.show();

      this.localValue = true;

      this.$emit('show');
    },
    hide() {
      this.collapse.hide();

      this.localValue = false;

      this.$emit('hide');
    },
  },
  watch: {
    localValue(value) {
      this.$emit('input', value);
      this.$emit('toggle', value);

      this.toggle();
    },
    value(value) {
      this.localValue = value;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "VCollapse";
</style>
